import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatPrice } from '../utils/priceFormatter';
import { getAssetDescription } from '../utils/assetDescriptions';
import { useTheme } from '../contexts/ThemeContext';

interface LivePriceBigProps {
  selectedSymbol: string;
  currentPrice: string;
  priceChange: string;
  isPricePositive: boolean;
  priceColor: string;
  isRightPanelVisible?: boolean;
}


const LivePriceBig: React.FC<LivePriceBigProps> = ({
  selectedSymbol,
  currentPrice,
  priceChange,
  isPricePositive,
  priceColor,
  isRightPanelVisible = false,
}) => {
  const { theme } = useTheme();
  return (
    <div className="py-0">
          {/* <div 
      className="absolute bottom-12 left-0 p-2"
      style={{
        width: isRightPanelVisible ? 'calc(100% - 15px)' : '100%',
        marginRight: isRightPanelVisible ? '15px' : '0'
      }}
    ></div> */}
      <div className={`theme-bg-secondary bg-opacity-95 p-3 py-4 rounded-lg z-10 shadow-xs bg-white relative ${theme === 'light' ? 'border-gray-200' : 'border-gray-800'}`}>
        <div className="flex flex-col items-center justify-center space-y-1 text-center">
          {/* Symbol + Price Label */}
          <div className="flex items-center justify-center">
            <h2 className="text-xs font-medium theme-text-white">
              {getAssetDescription(selectedSymbol)} <span className="text-xs">Price <span className="text-xs theme-text-white">
                {selectedSymbol === 'USD' ? 'usd' : 'USDT'}
              </span></span>
            </h2>
          </div>
          
          {/* Live Price */}
          <div className="flex items-center justify-center">
            <div className="flex items-baseline relative">
              <span className="live-price-text text-3xl font-bold theme-text-primary transition-all duration-300">
                <span
                  className={priceColor}
                  dangerouslySetInnerHTML={{ 
                    __html: formatPrice(parseFloat(currentPrice), selectedSymbol).replace(
                      /\$(\d+)/g, 
                      (match, digits) => `${parseInt(digits).toLocaleString()}`
                    )
                  }}
                />
              </span>
              
            </div>
          </div>
          
                      {/* Dollar Change + Arrow + Percentage */}
            <div className="flex items-center justify-center">
              {/* Calculate and display profit/loss in $ */}
              {(() => {
                // Parse percentage change and current price
                let percent = 0;
                let price = 0;
                try {
                  percent = parseFloat(
                    priceChange && priceChange.endsWith('%')
                      ? priceChange.replace('%', '')
                      : '0'
                  );
                  price = parseFloat(currentPrice);
                } catch {
                  percent = 0;
                  price = 0;
                }
                // Calculate previous price
                const prevPrice = price / (1 + percent / 100);
                // Calculate dollar change
                let dollarChange = price - prevPrice;
                // Format with sign, commas, and 2 decimals
                const sign = dollarChange > 0 ? '+' : '';
                const formattedDollarChange = `${sign}${dollarChange.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

                return (
                  <div className="flex items-center space-x-2">
                    {/* Dollar Change */}
                    <span className={`text-sm font-medium ${isPricePositive ? 'text-[#2AB7A6]' : 'text-red-400'}`}>
                      {formattedDollarChange}
                    </span>
                    
                    {/* Arrow + Percentage */}
                    <span className={`text-sm font-medium flex items-center ${isPricePositive ? 'text-[#2AB7A6]' : 'text-red-400'}`}>
                      {isPricePositive ? (
                        <TrendingUp className="h-3 w-3 mr-1" />
                      ) : (
                        <TrendingDown className="h-3 w-3 mr-1" />
                      )}
                      {priceChange && priceChange !== 'NaN%' ? priceChange : '+0.00%'}
                    </span>
                  </div>
                );
              })()}
            </div>
        </div>
      </div>
    </div>
  );
};

export default LivePriceBig;
